interface DayData {
    day: string;
    usage: number;
    billType: string;
    createDate: string;
}

interface UnifiedDayData {
    day: string;
    usage: number;
}

/**
 * Unifies days array by combining duplicate dates and summing their usage values
 * @param days - Array of day data that may contain duplicate dates
 * @returns Array with unique days and summed usage values
 */
export const unifyDaysUsage = (days: DayData[]): UnifiedDayData[] => {
    const daysMap = new Map<string, number>();

    days.forEach(({ day, usage }) => {
        const currentUsage = daysMap.get(day) || 0;
        daysMap.set(day, currentUsage + usage);
    });

    return Array.from(daysMap.entries()).map(([day, usage]) => ({
        day,
        usage,
    }));
}; 